<template>
  <BaseCard>
    <header class="items-center justify-between sm:flex">
      <div class="flex items-center">
        <span
          class="flex flex-col items-center justify-center w-10 h-10 mr-4 text-white rounded-full bg-secondary"
        >
          <Icon
            icon="Team"
            width="24px"
            height="24px"
            view-box="0 0 80.13 80.13"
          >
            <Team />
          </Icon>
        </span>
        <h2 class="text-lg">
          Your team
        </h2>
      </div>
      <AddTeamMemberButton
        class="mt-4 sm:text-right sm:mt-0"
        @createdTeamMember="fetchTeamMembers()"
      />
    </header>

    <TeamTable
      v-if="members.length > 0"
      :columns="columns"
      :table-data="members"
      class="mt-8"
    />
    <TeamEmpty
      v-if="members.length === 0 && !isLoading"
    />
    <div
      v-if="isLoading"
      class="p-16"
    >
      <Loader />
    </div>
  </BaseCard>
</template>

<script>
import Icon from '@components/Icons/Icon'
import Team from '@components/Icons/Team'
import AddTeamMemberButton from '@components/Teams/AddTeamMemberButton'
import TeamTable from '@components/Teams/TeamTable'
import TeamEmpty from '@components/Teams/TeamEmpty'
import Loader from '@components/Loader'

import membersApi from '@api/members'
import { mapGetters } from 'vuex'

export default {
  components: {
    AddTeamMemberButton,
    Icon,
    Team,
    TeamTable,
    TeamEmpty,
    Loader
  },

  data() {
    return {
      isLoading: false,
      members: [],
      columns: ['name', 'email']
    }
  },

  computed: {
    ...mapGetters({
      organisationId: 'employers/organisationId'
    })
  },

  created() {
    this.fetchTeamMembers()
  },

  methods: {
    /**
     * Fetch the team members for the organisation
     */
    fetchTeamMembers() {
      this.isLoading = true

      return membersApi.index(this.organisationId)
        .then(members => {
          this.members = members.filter(member => !member.deletedAt)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          throw error
        })
    }
  }
}
</script>
